import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
  --animation-duration: 5s;
  width: ${props => props.width};
  height: ${props => props.height};
  isolation: isolate;

  .text {
    fill: #333;
  }
  .dev {
    fill: #8153fd;
    mix-blend-mode: color-dodge;
  }
  .ux {
    fill: #7bffb0;
    mix-blend-mode: color-dodge;
  }
  &:hover,
  &:focus,
  &:active {
    g > .dev {
      animation: dev_rotate var(--animation-duration);
    }
    g > .ux {
      animation: ux_rotate var(--animation-duration);
    }
  }
  @keyframes ux_rotate {
    0% {
      transform: rotate(0deg);
      transform-origin: 10%;
    }
    3%,
    100% {
      transform: rotate(-90deg) translate(-50px, -90px);
      transform-origin: 10%;
    }
  }
  @keyframes dev_rotate {
    0% {
      transform: rotate(0deg);
      transform-origin: 10%;
    }
    3%,
    100% {
      transform: rotate(-270deg) translate(90px, -50px);
      transform-origin: 10%;
    }
  }
`;

export default props => (
  <SVG {...props} viewBox="0 0 1710 450">
    <g className="text">
      <path d="M628.177,301.514L628.177,143.935L676.117,143.935C689.301,143.935 700.387,145.689 709.376,149.197C718.364,152.705 725.705,157.825 731.398,164.557C737.091,171.289 741.186,179.443 743.683,189.019C746.18,198.595 747.428,209.451 747.428,221.587C747.428,234.102 746.08,244.768 743.383,253.586C740.687,262.404 737.241,269.752 733.046,275.63C728.851,281.508 724.107,286.154 718.814,289.567C713.521,292.981 708.177,295.588 702.784,297.389C697.391,299.191 692.297,300.329 687.503,300.803C682.709,301.277 678.714,301.514 675.518,301.514L628.177,301.514ZM599.713,121.18L599.713,324.269L673.121,324.269C690.899,324.269 706.28,321.898 719.263,317.158C732.247,312.417 742.934,305.543 751.323,296.536C759.713,287.529 765.905,276.436 769.9,263.257C773.895,250.078 775.892,234.955 775.892,217.889C775.892,185.274 767.004,161.002 749.226,145.073C731.448,129.145 706.08,121.18 673.121,121.18L599.713,121.18Z" />
      <path d="M849.656,121.18L849.656,324.269L998.27,324.269L998.27,301.514L878.121,301.514L878.121,231.258L989.282,231.258L989.282,208.503L878.121,208.503L878.121,143.935L997.372,143.935L997.372,121.18L849.656,121.18Z" />
      <path d="M1155.93,324.269L1232.03,121.18L1202.37,121.18L1140.65,297.247L1140.05,297.247L1078.93,121.18L1048.36,121.18L1123.57,324.269L1155.93,324.269Z" />
      <path d="M1464.6,250.884L1464.6,121.18L1436.13,121.18L1436.13,250.884C1436.13,269.088 1431.39,282.883 1421.9,292.269C1412.41,301.656 1398.58,306.349 1380.4,306.349C1361.23,306.349 1346.55,301.656 1336.36,292.269C1326.17,282.883 1321.08,269.088 1321.08,250.884L1321.08,121.18L1292.62,121.18L1292.62,250.884C1292.62,278 1300.36,297.769 1315.84,310.189C1331.32,322.609 1352.84,328.82 1380.4,328.82C1407.37,328.82 1428.14,322.325 1442.73,309.336C1457.31,296.346 1464.6,276.862 1464.6,250.884Z" />
      <path d="M1600.09,219.88L1525.78,324.269L1557.54,324.269L1616.87,240.36L1674.39,324.269L1709.15,324.269L1633.94,219.88L1704.65,121.18L1672.89,121.18L1617.16,200.538L1563.83,121.18L1529.67,121.18L1600.09,219.88Z" />
    </g>
    <g>
      <path
        className="dev"
        d="M150.485,0.001C233.049,0.263 300,67.374 300,150C300,232.787 232.787,300 150,300L0,300L0,150L0,0L150,0L150.485,0.001Z"
      />
      <path
        className="ux"
        d="M300,150L450,150L450,300C450,382.787 382.787,450 300,450C217.213,450 150,382.787 150,300L150,150L300,150Z"
      />
    </g>
  </SVG>
);
